import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import * as graphql from '@treams/treams-network';

import { formatSalaryScale } from '../../../job/formatSalaryScale';
import SettingsCollection, { ArchiveRestoreMutationTuple } from '../../generic/SettingsCollection';

export default function SalaryScalesListContainer() {
	const history = useHistory();
	const { i18n } = useTranslation();

	return (
		<SettingsCollection
			query={graphql.useSalaryScalesQuery}
			lazyQuery={graphql.useSalaryScalesLazyQuery}
			field="salaryScales"
			translationKey="settings.salaryScales"
			title={(scale: graphql.SalaryScale) => formatSalaryScale(scale, i18n.language) ?? scale.name}
			link={(scale) => `/settings/jobs/salary-scales/${scale.id}`}
			variables={{}}
			archive={graphql.useArchiveSalaryScaleMutation() as unknown as ArchiveRestoreMutationTuple}
			restore={graphql.useRestoreSalaryScaleMutation() as unknown as ArchiveRestoreMutationTuple}
			onAdd={() => history.push('/settings/jobs/salary-scales/new')}
		/>
	);
}
